<!-- @format -->

<mat-toolbar style="display: flex">
  <!-- <fa-icon icon="shopping-bag" class="headerIcon"></fa-icon> -->
  <span>{{ _common.locks_control }}</span>

  <div class="flex-auto"></div>
</mat-toolbar>
<div class="ctlSearchBar">
  <div class="searchField">
    <fa-icon matPrefix icon="search" class="searchIcon"></fa-icon>
    <input
      matInput
      (keyup)="applyFilter($any($event.target).value)"
      placeholder="{{ _common.search }}"
      #_search
    />
    <fa-icon
      icon="times"
      matSuffix
      (click)="clearFilter(_search)"
      class="clearSearch"
    ></fa-icon>
  </div>

  <!-- <div class="app-filter-bar">
    <div>
      <fa-icon icon="sliders-h"></fa-icon>
    </div>
    <div class="content">
      <app-filter-multi
            [filter]="status"
            #_status
            (change)="refresh()"
            [values]="[
              statusList.published,
              statusList.draft,
              statusList.expired,
              statusList.scheduled
            ]"
            [common]="_common.pricingRuleStatus"
            >{{ _common.Status }}</app-filter-multi
          >
    </div>
    <div (click)="filterObject.openFilter()" class="openFilter">
      <fa-icon icon="ellipsis-h"></fa-icon>
    </div>
  </div>
  <div class="app-btn btn-icon" (click)="refresh()">
    <fa-icon icon="sync"></fa-icon>
  </div> -->
  <div>
    <app-form-field>
      <mat-select [(ngModel)]="location" (selectionChange)="refresh()">
        <mat-option *ngFor="let l of locations" [value]="l">{{
          l.name
        }}</mat-option>
      </mat-select>
    </app-form-field>
  </div>

  <span class="spacer"></span>
</div>

<app-scroll-container
  [more]="hasMore()"
  (scrolled)="handleScroll($event)"
  class="max-scroll card-shadow"
  #scroll
>
  <table
    mat-table
    [dataSource]="objects"
    class="app-table scroll"
    matSort
    (matSortChange)="sortData($event)"
  >
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row" class="datatable-select">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
        {{ _common.name }}
      </th>
      <td mat-cell *matCellDef="let element">
        <!-- #{{ element.id }} -->
        {{ element.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>{{ _common.Type }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.type }}
      </td>
    </ng-container>
    <ng-container matColumnDef="agent">
      <th mat-header-cell *matHeaderCellDef>{{ _common.tablet }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.agent?.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="spaces">
      <th mat-header-cell *matHeaderCellDef>{{ _common.Space }}</th>
      <td mat-cell *matCellDef="let element">
        <div *ngFor="let s of element.spaces">
          {{ s.name }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="access">
      <th mat-header-cell *matHeaderCellDef>Access</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex space-x-1">
          <div class="app-chip" *ngIf="!element.access || element.access?.app">
            App
          </div>
          <div class="app-chip" *ngIf="!element.access || element.access?.card">
            Card
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="numCells">
      <th mat-header-cell *matHeaderCellDef># {{ _common.Cells }}</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.type == types.locker">
          {{ element.numCells }}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="controls" stickyEnd>
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="floating-buttons">
        <button
          class="app-btn btn-text"
          (click)="selectObject(element)"
          *ngIf="element.spaces?.length"
        >
          <fa-icon icon="lock-open"></fa-icon>
          {{ _common.unlock }}
        </button>
        <button class="app-btn btn-text" (click)="showAccess(element)">
          <fa-icon icon="clock-rotate-left"></fa-icon>
          {{ _common.door_log }}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="datatable-row"
    ></tr>
  </table>
</app-scroll-container>

<div
  *ngIf="filterObject.showFilter"
  class="ctlFilter listFilter"
  (clickOutsidePopup)="filterObject.closeFilter()"
>
  <div class="header">
    <div class="title">
      <fa-icon icon="sliders-h" style="margin-right: 5px"></fa-icon>
      {{ _common.filters }}
    </div>
    <div class="spacer"></div>
    <div
      (click)="filterObject.closeFilter()"
      style="font-size: 1.5em; cursor: pointer"
    >
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>
  <div class="body"></div>
  <div class="buttons">
    <div (click)="filterObject.clear(); refresh()" class="clear_button">
      {{ _common.ClearAll }}
    </div>
  </div>
</div>
